"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const reports = (state = {}, action) => {
    if (action.reportConnection) {
        return action.reportConnection.reports;
    }
    return state;
};
const months = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
};
const pageInfo = (state = {}, action) => {
    if (action.reportConnection) {
        return action.reportConnection.pageInfo;
    }
    return state;
};
exports.default = redux_1.combineReducers({
    pageInfo,
    reports,
});
exports.getFormattedReport = (state, reportGraphType) => {
    return Object.keys(state.reports).map((key) => {
        const _a = state.reports[key][reportGraphType], { id, cursor } = _a, rest = __rest(_a, ["id", "cursor"]);
        return Object.assign({ name: `${months[id.substr(5, 2)]} ${id.substr(8, 2)}, ${id.substr(0, 4)}` }, rest);
    });
};
exports.getReportConnection = (state) => state.reports;
exports.getReport = (state) => state;
exports.getReportHasNextPage = (state) => {
    return state.pageInfo.hasNextPage;
};
exports.getReportHasPreviousPage = (state) => {
    return state.pageInfo.hasPreviousPage;
};
exports.getReportStartCursor = (state) => {
    return state.pageInfo.startCursor;
};
exports.getReportEndCursor = (state) => {
    return state.pageInfo.endCursor;
};
